<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-10 10:49:59
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimItemType\ClaimItemType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:23:19
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_ClaimItemType_list_title')"
    pad="0"
    :addBtn="hasBtn('add-claim-item')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.claim_item_type_name) }}
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <tableListTools
            :delBtn="hasBtn('delete-claim-item')"
            :editBtn="hasBtn('edit-claim-item')"
            :viewBtn="hasBtn('view-claim-item')"
            :uuid="item.uuid"
            :title="$t('label_essweb_ClaimItemType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main></template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
export default {
  name: "ClaimItemType",
  computed: {},
  data() {
    return {
      showSelect: false,
      headers: [
        {
          text: "label_essweb_ClaimItemType_list_claimItemTypeLabel",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      totalCount: 0,
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/get-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_item_type",
        url: "/claim-item-type/delete/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimItemType_list_deleteClaimItemTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toNew: function () {
      this.$toPage("/admin/claim-item/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/claim-item/edit/"
          : "/admin/claim-item/detail/") + uuid
      );
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>